









import { Component, Vue } from 'vue-property-decorator';
import LeftNav from '../../components/LeftNav.vue';
import { NavList } from '@/store/pages/report/index.d';

@Component({
  components: {
    LeftNav,
  },
})
export default class Index extends Vue {
  private navList: NavList[] = [{
    name: '二手车业务',
    icon: 'bi-icon-vehicle',
    path: '/index/report/summary',
    hasAuth: false,
  }];
}
